// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#vue-wp-app .smart-press-popup[data-v-d55f5a0a]{position:relative;overflow:visible;-webkit-user-select:none;-moz-user-select:none;user-select:none}#vue-wp-app .pointer-events-none[data-v-d55f5a0a]{pointer-events:none}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
